import * as TypesConfig from '../types/types_config';
import Vue from 'vue';

export default {
    state: {
        recommendQuestionConfig: []
    },
    getters: {
    },
    mutations: {
        [TypesConfig.CONFIG_SET_RECOMMEND_QUESTION_CONFIG](state, payload) {
            state.recommendQuestionConfig = payload;
        }
    },
    actions: {
        [TypesConfig.CONFIG_GET_RECOMMEND_QUESTION_CONFIG](ctx) {
            return Vue.http.get('/v1/config/recommend-question-config')
                .then(resp => Vue.checkResp(resp))
                .then(data => {
                    ctx.commit(TypesConfig.CONFIG_SET_RECOMMEND_QUESTION_CONFIG, data.recommendQuestionConfig);
                });
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/index/store/modules/modules_config.js